export enum NegoTermsResponse {
    acceptedByCustomer = 1, //
    acceptedByVendor = 2, //
    counteredByCustomer = 3, //
    counteredByVendor = 4,
    rejectedByCustomer = 5, //
    rejectedByVendor = 6, //
  }
